import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { ResourceStatus } from '@thiememeulenhoff/types';

export const resourceStatus = createStore(
  { name: 'resourceStatus' },
  withEntities<ResourceStatus, 'identifier'>({
    idKey: 'identifier',
  }),
);
